var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyFlights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 454.069,
    height: 334.402,
    viewBox: "0 0 454.069 334.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5510",
    "data-name": "Group 5510",
    transform: "translate(-820 -338.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5438",
    "data-name": "Group 5438",
    transform: "translate(820 338.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6147",
    "data-name": "Path 6147",
    d: "M479.662,150.747c-5.358-15.021-15.193-28.943-29.225-36.524-18.227-9.847-40.612-7.856-60.05-15.024-14.994-5.529-27.434-16.188-41.114-24.449A142.371,142.371,0,0,0,270.15,54.526c-57.527,2.459-107.556,39.089-163.064,54.4-19.254,5.31-42.262,10.445-49.882,28.907l1.827-1.275a40.11,40.11,0,0,0-5.178,21.569c.574,13.9,5.531,27.818,2.768,41.454-2.333,11.511-9.854,21.163-15.136,31.653C28,258.012,29.914,291.914,46.331,317.007s46.712,40.428,76.654,38.8c28.4-1.544,54.934-17.033,83.373-16.763,44.531.422,80.036,38.483,123.608,47.686,46.066,9.729,94.652-15.911,121.759-54.406s35.624-87.377,34.848-134.453C486.309,181.926,485.019,165.769,479.662,150.747Z",
    transform: "translate(-32.551 -54.4)",
    fill: "#dde4eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5439",
    "data-name": "Group 5439",
    transform: "translate(1056.367 453.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6148",
    "data-name": "Path 6148",
    d: "M357.007,208.284c-1.289-.3-2.727.063-3.808-.724-.381-.278-.039-1.015-.912-1.362-.357-.142-.646,0-.976.01-.891.021-1.169.909-2.234,1-1.421.12-3.2-.956-2.785-2.455.363-1.309,2.581-1.563,2.717-3.276a5.1,5.1,0,0,0-1.811-3.339c-.723-.4-1.979.023-2.768-.286-1.077-.422-1.579-1.321-2.4-2.071-2.176-1.982-5.093-4.772-8.156-4.917a8.646,8.646,0,0,1-2.4.032c-1.145-.354-2.119-1.75-3.37-1.6-1.563.185-1.374,3.087-3.4,2.255.4-1.91.87-3.607-1.794-3.171a10.837,10.837,0,0,0-5.811,3.678l.592,1.284-.18,1.642-1.177-1.09c-.375,1.758-.34,3.879-1.646,4.7-.787.493-1.6.115-2.395.8a7.212,7.212,0,0,0-1.88,3.938c-.052,1.561,1.142,1.644,1.291,2.827.17,1.35-.673,1.083-1.553,1.669-2.478,1.651-.708,2,1.044,3.63a6.454,6.454,0,0,1,1.9,2.46c.447,1.236-.143,1.722-.056,2.918.129,1.8,1.948,2.658,3.372,3.6,1.385.919,5.007,1.775,5.675,3.138.514,1.049-.736,3.778-1.2,4.638-3.091,3.417-3.41,7.054-5.173,9.943-1.727,2.832-1.436,5.828-2.845,8.646-1.116,2.234-4.251,3.164-2.129,6.115a3.572,3.572,0,0,0,1.291,1.116q1.944-.145,3.863-.4a36.572,36.572,0,0,0,4.775-4.045,5.25,5.25,0,0,0,1.553-2.255c.2-.5.208-1.557.6-1.883.469-.389,1.358-.048,1.886-.356.253-.148.26-.684.647-.871,1.718-.83,4.086.142,5.75-.883,1.575-.97.725-1.438,1.4-2.778.526-1.041,1.532-.932,2.669-1.209,2.354-.574,2.733-1.352,4.416-2.924,1.814-1.7,4.275-2.613,6.444-3.815,2.408-1.336,4.091-3.244,6.2-4.97,2.053-1.681,3.149-2.432,3.967-4.984,1.36-4.245,5.721-6.471,5.349-11.277C359.019,210.96,359.592,208.887,357.007,208.284Z",
    transform: "translate(-308.925 -188.306)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5440",
    "data-name": "Group 5440",
    transform: "translate(1013.176 370.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6149",
    "data-name": "Path 6149",
    d: "M353.841,120.643c-.217.232-.048,1.05-.349,1.308-.9.768-2.567-.156-3.3-.616-2.491-1.563-3.852-4.363-6.308-5.97-.65-.425-2.5-.967-.983-1.7-.6-1.542-3.157-3.238-4.748-3.453.111-3.524-.977-2.461-4.074-3.447-2.468-.786-5.238-3.315-9.1-3.64-1.344.027-1.959-1.421-2.763-2.3,1.191-.644,3.673.071,5.182-.1a23.081,23.081,0,0,1,4.44-.232,34.458,34.458,0,0,1,3.6.274,71.652,71.652,0,0,0-77.015,3.829,18.491,18.491,0,0,1,6.415-.5c1.758.192,6.526,1.085,6.465-.531s-.127-2.1-1.9-2.174-5.8-.157-2.413-1.805a13.563,13.563,0,0,1,8.283-.876c1.277.257,4.5-1.051,6.248-1.81s6.261-1.928,3.429,1.2-5.439,6.356-5.439,6.356-4.508,2.169.8,1.325c3.275-.52,5.341-1.535,7.3-1.922-2.75-.556-4.883-1.446-4.845-2.873,2.224-.759,5.073.8,7.412.61,1.273-.1,2.437-.721,3.787-.74a26.759,26.759,0,0,1,6.744,1.177c1.459.369,4.108,1.627,5.354.272a22.153,22.153,0,0,0-4.33-3.764c-2.084-1.351-6.717-.832-7.623-3.1,1.913-.287,3.576-.81,5.557-.607,3.156.325,6.308.692,9.462,1.036,3.7.4,8.788.02,12.185,1.686,1.11,2.062-.631,1.306-2.242,1.244-3.379-.131-8.338.121-11.4,1.532,3.076,1.535-.554,3.607-.437,5.582-1.3.555-3.009.238-4.4.334,1.238.665,2.648.948,3.9,1.583-1.71.263-3.376.814-5.1.99a1.8,1.8,0,0,1,.154-.187c-1.09-.82-3.554-1.543-3.668-2.939a1.049,1.049,0,0,0,1.211-.914c-.443,0-3.5.006-6.87-.277,3.1,1.031,5.3,1.232,5.342.809a12.106,12.106,0,0,1-1.669,5.513c-1.791,3.364,11.259,5.589,11.512,6.521s.494,5.23,3.359,5.067,2.061-3.1,2.061-3.1l2.41-1.116.363-3.327-2.107-1.654,2.506-1.992s3.874,2.925,8.934,7.037l5.777-1.505,7.495,7.936s1.126,2.022-.205,1.876-11.247.434-11.247.434l-2.009,2.153a28.848,28.848,0,0,0,4.56.5c1.094-.118,3.519,1.571,3.519,1.571s3.79,2.312,1.716,2.8-9.991,1.283-9.991,1.283.626-2.3-1.226-2.269-2.5,3.761-4.189,4.051-4.778-1-5.214.381.133,3.573-.487,4.455-5.1,2.767-5.1,2.767l-2.437,8.964-4.462-6.632-4.558.452-2,.967-3.217-1.538-7.33,2.523,1.565,9.578,4.085,3.306,4.074-4.145,4.269,2.195-2.356,4.2-.22,2.01,6.217.678,1.99,4.251-2.707,2.314,3.662,2.3,3.964.433.674,1.464a10.837,10.837,0,0,1,5.811-3.678c2.664-.435,2.195,1.261,1.794,3.171,2.029.832,1.84-2.071,3.4-2.255,1.25-.147,2.224,1.249,3.37,1.6a8.646,8.646,0,0,0,2.4-.032c3.063.145,5.98,2.934,8.156,4.917.824.75,1.326,1.649,2.4,2.071.789.31,2.045-.115,2.768.286a5.1,5.1,0,0,1,1.811,3.339c-.136,1.714-2.354,1.968-2.717,3.276-.417,1.5,1.363,2.575,2.785,2.455,1.065-.09,1.343-.978,2.234-1,.33-.009.618-.152.976-.01.872.346.531,1.084.912,1.362,1.08.787,2.519.423,3.808.724,2.585.6,2.012,2.676,4.543,3.1.372,4.806-3.989,7.033-5.349,11.277-.818,2.552-1.913,3.3-3.967,4.984-2.108,1.726-3.791,3.634-6.2,4.97-2.169,1.2-4.63,2.119-6.444,3.815-1.683,1.572-2.062,2.35-4.416,2.924-1.137.277-2.143.168-2.669,1.209-.677,1.34.172,1.808-1.4,2.778-1.664,1.025-4.032.053-5.75.883-.387.187-.394.724-.647.871-.528.308-1.417-.033-1.886.356-.393.326-.4,1.384-.6,1.883a5.25,5.25,0,0,1-1.553,2.255,36.572,36.572,0,0,1-4.775,4.045c30.648-3.992,56.192-27.653,62.457-59.342a18.265,18.265,0,0,1-.4-1.973,40.186,40.186,0,0,1,1.177-10.787c.216-.739.447-1.426.682-2.055a74.886,74.886,0,0,0-15.124-45.331C355.885,120.218,354.875,119.54,353.841,120.643Zm-25.975-8.7a1.35,1.35,0,0,0,1.581,1.511c.623,2.335-2.537.375-3.181.038-1.244-.647-8.635-1.982-8.3-3.546.232-1.089,1.871-.422,1.785-1.835-.063-1.048-2.17-2.4-2.859-2.859-1.363-.907-5.481-1.228-6.149-2.688-.738-1.614,1.354-2.1,2.633-2.13,3.046-.067,5.086,2.407,7.619,3.323,2.207,1.794,9.277,4.672,10.011,8.365A14.956,14.956,0,0,0,327.866,111.939Zm-15.995,52.575c-.242.643-.926.663-1.468.2.079-.854,1-.484,1.611-.426Zm-3.044-4.722-2.658-.646c-.811-.429-3.265.08-2.92-1.4a14.706,14.706,0,0,1,6.288.727c1.036.453,1.531,1.415,2.544,1.938.953.492,1.585.468,1.968,1.562C311.9,162.257,310.742,160.023,308.827,159.792Zm11.963,4.86c-.415.287-.623,1.179-1.019,1.583-.233-1.405-1.706-1.444-2.338-2.453.4-.751,1.2-.422,1.912-.352l.925.22c.73.2,2.454.107,2.623.921C322.282,164.63,321.356,164.261,320.79,164.653Zm4.468,1.451c-1.4,1.293-.726-.85-.7-1.51l-.26.209C324.814,163.9,326.36,165.085,325.258,166.1Zm12.535-34.831c-1.142-1.976.405-2.717.991-4.637l.677.311c-.8,3.375,1.368,4.4,3.5,6.285C341.238,133.095,338.805,133.027,337.794,131.273Z",
    transform: "translate(-258.421 -91.342)",
    fill: "#089ecb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5441",
    "data-name": "Group 5441",
    transform: "translate(1094.012 381.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6150",
    "data-name": "Path 6150",
    d: "M353.922,105.763q-.487-.332-.981-.657A7.814,7.814,0,0,0,353.922,105.763Z",
    transform: "translate(-352.941 -105.106)",
    fill: "#2181f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5442",
    "data-name": "Group 5442",
    transform: "translate(981.514 392.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6151",
    "data-name": "Path 6151",
    d: "M303.737,210.256c-1.424-.945-3.243-1.808-3.372-3.6-.086-1.2.5-1.682.056-2.918a6.454,6.454,0,0,0-1.9-2.46c-1.752-1.631-3.523-1.98-1.044-3.63.88-.586,1.723-.318,1.553-1.669-.15-1.184-1.344-1.267-1.291-2.827a7.212,7.212,0,0,1,1.88-3.938c.793-.688,1.608-.31,2.395-.8,1.307-.819,1.272-2.94,1.646-4.7l-2.323-2.15-3.144-.343-4.768-3.832-2.012-3.3-4.562-1.684-3.6-3.972-4.221-.46-10.352-5.172-1.162-6.744-4.7-4.784-3.215-5.333-1.172-.128,4.334,8.118,1.182,2.213-6.37-6.865-2.383-6.43-4.2-5,.786-9.376,3.172-2.976-5.327-.107-1.154-3.566-1.944-1.755-1.587,2.082-1.152-4.16-2,.275a75.163,75.163,0,0,0-19.928,43.465c-4.459,40.87,24.348,77.539,64.343,81.9a71.723,71.723,0,0,0,13.159.225,3.572,3.572,0,0,1-1.291-1.116c-2.122-2.951,1.013-3.881,2.129-6.115,1.409-2.818,1.118-5.814,2.845-8.646,1.763-2.889,2.082-6.526,5.173-9.943.464-.86,1.714-3.589,1.2-4.638C308.744,212.031,305.122,211.175,303.737,210.256Z",
    transform: "translate(-221.401 -117.984)",
    fill: "#089ecb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5443",
    "data-name": "Group 5443",
    transform: "translate(1125.367 444.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6152",
    "data-name": "Path 6152",
    d: "M389.631,190.824a18.265,18.265,0,0,0,.4,1.973c.428-2.159.77-4.354,1.013-6.585a76.715,76.715,0,0,0,.45-8.231c-.234.629-.466,1.316-.682,2.055A40.186,40.186,0,0,0,389.631,190.824Z",
    transform: "translate(-389.602 -177.982)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5444",
    "data-name": "Group 5444",
    transform: "translate(1076.967 379.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6153",
    "data-name": "Path 6153",
    d: "M351.037,105.312a7.814,7.814,0,0,1-.981-.657q-1.872-1.232-3.823-2.351a34.458,34.458,0,0,0-3.6-.274,23.081,23.081,0,0,0-4.44.232c-1.509.169-3.991-.546-5.182.1.8.881,1.42,2.33,2.763,2.3,3.862.325,6.632,2.854,9.1,3.64,3.1.987,4.186-.076,4.074,3.447,1.592.215,4.145,1.911,4.748,3.453-1.521.736.333,1.279.983,1.7,2.456,1.606,3.817,4.407,6.308,5.97.734.46,2.4,1.384,3.3.616.3-.257.132-1.076.349-1.308,1.033-1.1,2.043-.424,3.535-.534A73.231,73.231,0,0,0,351.037,105.312Z",
    transform: "translate(-333.011 -101.994)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5445",
    "data-name": "Group 5445",
    transform: "translate(1057.971 436.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6154",
    "data-name": "Path 6154",
    d: "M319.663,171.644c-1.013-.523-1.509-1.485-2.544-1.938a14.706,14.706,0,0,0-6.288-.727c-.345,1.477,2.109.968,2.92,1.4l2.658.646c1.915.231,3.073,2.465,5.222,2.183C321.248,172.112,320.616,172.135,319.663,171.644Z",
    transform: "translate(-310.798 -168.918)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5446",
    "data-name": "Group 5446",
    transform: "translate(1072.188 442.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6155",
    "data-name": "Path 6155",
    d: "M330.259,175.83l-.925-.22c-.708-.071-1.513-.4-1.912.352.632,1.009,2.106,1.048,2.338,2.453.4-.4.6-1.3,1.019-1.583.565-.392,1.492-.022,2.1-.08C332.713,175.937,330.989,176.03,330.259,175.83Z",
    transform: "translate(-327.422 -175.478)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5447",
    "data-name": "Group 5447",
    transform: "translate(1079.053 443.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6156",
    "data-name": "Path 6156",
    d: "M335.448,177.182l.26-.209c-.026.66-.7,2.8.7,1.51C337.51,177.465,335.965,176.276,335.448,177.182Z",
    transform: "translate(-335.448 -176.86)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5448",
    "data-name": "Group 5448",
    transform: "translate(1065.156 443.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6157",
    "data-name": "Path 6157",
    d: "M319.2,177.044c.542.458,1.226.439,1.468-.2l.143-.222C320.2,176.56,319.28,176.19,319.2,177.044Z",
    transform: "translate(-319.201 -176.489)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5449",
    "data-name": "Group 5449",
    transform: "translate(1001.896 374.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6158",
    "data-name": "Path 6158",
    d: "M329.041,117.56l-5.777,1.505c-5.06-4.112-8.934-7.037-8.934-7.037l-2.506,1.992,2.107,1.654L313.569,119l-2.41,1.116s.8,2.935-2.061,3.1-3.108-4.136-3.359-5.067-13.3-3.158-11.512-6.521a12.106,12.106,0,0,0,1.669-5.513c-.046.422-2.242.222-5.342-.809a43.635,43.635,0,0,1-4.852-.648c-1.958.387-4.024,1.4-7.3,1.922-5.312.844-.8-1.325-.8-1.325s2.606-3.224,5.439-6.356-1.685-1.964-3.429-1.2-4.971,2.067-6.248,1.81a13.563,13.563,0,0,0-8.283.876c-3.382,1.648.642,1.731,2.413,1.805s1.838.557,1.9,2.174-4.706.724-6.465.531a18.491,18.491,0,0,0-6.415.5,74.242,74.242,0,0,0-11.278,9.811l2-.275,1.152,4.16L249.978,117l1.944,1.755,1.154,3.566,5.327.107-3.172,2.976-.786,9.376,4.2,5,2.383,6.43,6.37,6.865-1.182-2.213-4.334-8.118,1.172.128,3.215,5.333,4.7,4.784,1.162,6.744,10.352,5.172,4.221.46,3.6,3.972,4.562,1.684,2.012,3.3,4.768,3.832,3.144.343,2.323,2.15a4.53,4.53,0,0,1,.658-1.7c.033-.047.072-.094.107-.14l-.674-1.464-3.964-.433-3.662-2.3,2.707-2.314-1.99-4.251-6.217-.678.22-2.01,2.356-4.2-4.269-2.195-4.074,4.145-4.085-3.306-1.565-9.578,7.33-2.523,3.217,1.538,2-.967,4.558-.452,4.462,6.632,2.437-8.964s4.477-1.885,5.1-2.767.051-3.079.487-4.455,3.521-.091,5.214-.381,2.337-4.016,4.189-4.051,1.226,2.269,1.226,2.269,7.917-.8,9.991-1.283-1.716-2.8-1.716-2.8-2.426-1.689-3.519-1.571a28.848,28.848,0,0,1-4.56-.5l2.009-2.153s9.917-.579,11.247-.434.205-1.876.205-1.876Z",
    transform: "translate(-245.234 -96.835)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5450",
    "data-name": "Group 5450",
    transform: "translate(1063.775 456.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6159",
    "data-name": "Path 6159",
    d: "M318.243,192.827a4.53,4.53,0,0,0-.658,1.7l1.177,1.09.18-1.642-.592-1.284C318.315,192.733,318.276,192.78,318.243,192.827Z",
    transform: "translate(-317.585 -192.687)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5451",
    "data-name": "Group 5451",
    transform: "translate(1092.139 405.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6160",
    "data-name": "Path 6160",
    d: "M352.827,132.921l-.677-.311c-.586,1.92-2.133,2.661-.991,4.637,1.012,1.754,3.444,1.822,5.166,1.959C354.195,137.322,352.023,136.3,352.827,132.921Z",
    transform: "translate(-350.749 -132.61)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5452",
    "data-name": "Group 5452",
    transform: "translate(1065.34 379.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6161",
    "data-name": "Path 6161",
    d: "M339.833,113.658c-.735-3.693-7.8-6.571-10.011-8.365-2.532-.916-4.573-3.389-7.619-3.323-1.279.028-3.371.516-2.633,2.13.668,1.46,4.786,1.781,6.149,2.688.689.458,2.8,1.811,2.859,2.859.086,1.412-1.553.746-1.785,1.835-.333,1.563,7.058,2.9,8.3,3.546.645.336,3.8,2.3,3.181-.038a1.35,1.35,0,0,1-1.581-1.511A14.956,14.956,0,0,1,339.833,113.658Z",
    transform: "translate(-319.416 -101.968)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5453",
    "data-name": "Group 5453",
    transform: "translate(1037.52 373.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6162",
    "data-name": "Path 6162",
    d: "M313.248,96.459c-3.153-.344-6.306-.711-9.462-1.036-1.981-.2-3.643.321-5.557.607.906,2.264,5.539,1.745,7.623,3.1a22.153,22.153,0,0,1,4.33,3.764c-1.246,1.355-3.895.1-5.354-.272a26.759,26.759,0,0,0-6.744-1.177c-1.35.019-2.514.636-3.787.74-2.338.19-5.188-1.369-7.412-.61-.038,1.427,2.1,2.317,4.845,2.873a6.61,6.61,0,0,1,3.8.279c.363.135.713.256,1.055.369,3.37.283,6.427.276,6.87.277a1.049,1.049,0,0,1-1.211.914c.114,1.4,2.578,2.118,3.668,2.939a1.8,1.8,0,0,0-.154.187c1.722-.175,3.388-.727,5.1-.99-1.256-.635-2.667-.919-3.9-1.583,1.395-.1,3.1.221,4.4-.334-.117-1.976,3.513-4.047.437-5.582,3.062-1.411,8.021-1.663,11.4-1.532,1.61.062,3.352.818,2.242-1.244C322.037,96.479,316.944,96.862,313.248,96.459Z",
    transform: "translate(-286.886 -95.378)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5454",
    "data-name": "Group 5454",
    transform: "translate(1042.365 382.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6163",
    "data-name": "Path 6163",
    d: "M292.552,105.953a43.635,43.635,0,0,0,4.852.648c-.342-.114-.693-.234-1.055-.369A6.61,6.61,0,0,0,292.552,105.953Z",
    transform: "translate(-292.552 -105.797)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5467",
    "data-name": "Group 5467",
    transform: "translate(933.672 536.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5456",
    "data-name": "Group 5456",
    transform: "translate(25.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6164",
    "data-name": "Path 6164",
    d: "M203.555,286.4l-7.917,2.227a.8.8,0,0,0,.428,1.551l7.917-2.227A.8.8,0,0,0,203.555,286.4Z",
    transform: "translate(-195.071 -286.367)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5457",
    "data-name": "Group 5457",
    transform: "translate(11.338 6.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6165",
    "data-name": "Path 6165",
    d: "M185.6,293.564l-6.539,4.989c-.812.619-.012,2.017.812,1.388l6.539-4.989C187.22,294.333,186.42,292.935,185.6,293.564Z",
    transform: "translate(-178.719 -293.405)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5458",
    "data-name": "Group 5458",
    transform: "translate(2.284 17.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6166",
    "data-name": "Path 6166",
    d: "M172.376,306.708l-4.128,7.113a.8.8,0,0,0,1.388.812l4.128-7.113A.8.8,0,0,0,172.376,306.708Z",
    transform: "translate(-168.133 -306.318)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5459",
    "data-name": "Group 5459",
    transform: "translate(0 31.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6167",
    "data-name": "Path 6167",
    d: "M165.544,324.067l-.082,8.225a.8.8,0,0,0,1.608,0q.041-4.113.083-8.225A.8.8,0,0,0,165.544,324.067Z",
    transform: "translate(-165.462 -323.29)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5460",
    "data-name": "Group 5460",
    transform: "translate(1.168 46.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6168",
    "data-name": "Path 6168",
    d: "M168.412,341.764a.8.8,0,0,0-1.551.427q1.116,3.959,2.233,7.916a.8.8,0,0,0,1.551-.428Q169.527,345.722,168.412,341.764Z",
    transform: "translate(-166.827 -341.197)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5461",
    "data-name": "Group 5461",
    transform: "translate(8.23 60.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6169",
    "data-name": "Path 6169",
    d: "M176.476,357.227c-.762-.7-1.9.436-1.137,1.137l6.062,5.559c.761.7,1.9-.436,1.137-1.137Z",
    transform: "translate(-175.085 -357.008)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5462",
    "data-name": "Group 5462",
    transform: "translate(22.037 69.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6170",
    "data-name": "Path 6170",
    d: "M200.2,368.453l-8.2-.645c-1.031-.081-1.026,1.527,0,1.608l8.2.645C201.232,370.142,201.227,368.534,200.2,368.453Z",
    transform: "translate(-191.229 -367.806)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5463",
    "data-name": "Group 5463",
    transform: "translate(38.428 67.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6171",
    "data-name": "Path 6171",
    d: "M218.976,365.641l-8.007,1.88c-1.007.236-.581,1.788.428,1.551l8.007-1.88C220.411,366.955,219.984,365.4,218.976,365.641Z",
    transform: "translate(-210.394 -365.616)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5464",
    "data-name": "Group 5464",
    transform: "translate(55.084 60.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6172",
    "data-name": "Path 6172",
    d: "M237.411,357.1q-3.575,2.032-7.149,4.067a.8.8,0,0,0,.812,1.388l7.149-4.067A.8.8,0,0,0,237.411,357.1Z",
    transform: "translate(-229.869 -356.987)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5465",
    "data-name": "Group 5465",
    transform: "translate(66.603 49.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6173",
    "data-name": "Path 6173",
    d: "M248.171,344.5l-4.69,6.756c-.591.852.8,1.657,1.389.812l4.689-6.756C250.151,344.461,248.758,343.657,248.171,344.5Z",
    transform: "translate(-243.338 -344.144)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5466",
    "data-name": "Group 5466",
    transform: "translate(21.814 45.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6174",
    "data-name": "Path 6174",
    d: "M190.975,343.906c-.109,3.667,1.116,9.136,5.128,17.283,4.012-8.147,5.238-13.615,5.128-17.283C201.037,337.364,191.169,337.364,190.975,343.906Zm5.128,3.507a3.066,3.066,0,1,1,3.066-3.066A3.066,3.066,0,0,1,196.1,347.413Z",
    transform: "translate(-190.968 -338.999)",
    fill: "#536dfe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5486",
    "data-name": "Group 5486",
    transform: "translate(1110.51 409.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5468",
    "data-name": "Group 5468",
    transform: "translate(44.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6175",
    "data-name": "Path 6175",
    d: "M468.943,145.732q-8.381,2.074-16.76,4.151a.485.485,0,0,1-.605-.205c-.187-.273-.411-.521-.619-.779a1.7,1.7,0,0,0-1.156-.672,2.289,2.289,0,0,0-2.077,1.913,4.607,4.607,0,0,0,.165.784c-.066.019-.151.048-.237.069-1.888.469-3.776.931-5.66,1.41a.517.517,0,0,1-.59-.18c-3.693-4.026-7.373-8.062-11.1-12.053a7.743,7.743,0,0,0-4.61-2.39c-1.179-.175-1.835.456-1.8,1.647,0,.068,0,.138.011.206a8.132,8.132,0,0,0,2.014,4.614c3.65,4.017,7.34,8,11.022,11.987a.616.616,0,0,1,.159.719c-.457,1.295-.885,2.6-1.326,3.9-.2.6-.411,1.208-.627,1.841a1.476,1.476,0,0,0-2.1.351,1.948,1.948,0,0,1-.151.14,1.476,1.476,0,0,0,.007,2.372c.218.2.417.428.651.611a.559.559,0,0,1,.183.733q-2.39,7.019-4.753,14.047c-.325.96-.653,1.921-.986,2.9l1.295,1.407a4.657,4.657,0,0,0,.449-.488q3.868-5.648,7.724-11.3l1.458-2.134c.118.112.21.2.3.285s.186.2.287.3c.33.3.463.308.793.015.36-.318.706-.652,1.061-.976a.394.394,0,0,0,.067-.6c-.266-.329-.525-.664-.807-.978a.367.367,0,0,1-.007-.533c.691-1,1.369-2,2.053-3,.431-.63.866-1.258,1.326-1.926.11.121.192.213.278.3.948.977,1.86,1.994,2.856,2.919,2.414,2.245,4.866,4.449,7.31,6.661a.544.544,0,0,1,.2.561q-.818,5.174-1.615,10.35c-.015.1-.046.231,0,.29.2.253.434.485.7.773l4.6-8.37c.895.459,1.512.44,2.065-.044.582-.51.669-1.113.29-2.122l8.72-3.884a6.852,6.852,0,0,1-.475-.523.635.635,0,0,0-.639-.266q-5.188.387-10.378.741a.573.573,0,0,1-.431-.163c-1.128-1.443-2.235-2.9-3.356-4.351a70.415,70.415,0,0,0-5.467-6.7,3.036,3.036,0,0,1-.193-.236.662.662,0,0,1,.094-.086q2.58-1.466,5.166-2.922a.376.376,0,0,1,.343.039c.308.273.584.581.884.863s.452.288.766.009c.335-.3.664-.6.988-.906.346-.327.354-.464.045-.842-.162-.2-.343-.376-.532-.582.18-.107.287-.172.4-.234q6.862-3.892,13.723-7.787a6.376,6.376,0,0,0,.588-.434l-1.315-1.43C469.356,145.613,469.152,145.681,468.943,145.732Z",
    transform: "translate(-423.888 -137.751)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5485",
    "data-name": "Group 5485",
    transform: "translate(0 46.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5469",
    "data-name": "Group 5469",
    transform: "translate(84.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6176",
    "data-name": "Path 6176",
    d: "M472.7,192.444a.8.8,0,0,0-1.551.428q1.161,3.945,2.321,7.89a.8.8,0,0,0,1.551-.428Q473.866,196.39,472.7,192.444Z",
    transform: "translate(-471.117 -191.88)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5470",
    "data-name": "Group 5470",
    transform: "translate(87.667 14.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6177",
    "data-name": "Path 6177",
    d: "M474.738,209.374q.092,4.112.184,8.222a.8.8,0,0,0,1.608,0q-.092-4.112-.183-8.222A.8.8,0,0,0,474.738,209.374Z",
    transform: "translate(-474.738 -208.597)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5471",
    "data-name": "Group 5471",
    transform: "translate(85.371 29.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6178",
    "data-name": "Path 6178",
    d: "M473.776,226.879q-.852,4.023-1.7,8.046c-.214,1.009,1.336,1.441,1.55.428l1.7-8.046C475.541,226.3,473.991,225.866,473.776,226.879Z",
    transform: "translate(-472.053 -226.301)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5472",
    "data-name": "Group 5472",
    transform: "translate(80.159 43.682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6179",
    "data-name": "Path 6179",
    d: "M469.582,243.369l-3.536,7.425c-.443.93.942,1.746,1.388.812l3.537-7.425C471.413,243.251,470.027,242.434,469.582,243.369Z",
    transform: "translate(-465.959 -242.956)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5473",
    "data-name": "Group 5473",
    transform: "translate(71.457 58.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6180",
    "data-name": "Path 6180",
    d: "M460.056,261.229l-4.156,7.1a.8.8,0,0,0,1.389.812q2.077-3.548,4.155-7.1A.8.8,0,0,0,460.056,261.229Z",
    transform: "translate(-455.784 -260.842)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5474",
    "data-name": "Group 5474",
    transform: "translate(31.234 119.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6181",
    "data-name": "Path 6181",
    d: "M417.478,331.948l-8.143,1.161c-1.02.145-.586,1.694.428,1.551l8.142-1.161C418.926,333.354,418.492,331.8,417.478,331.948Z",
    transform: "translate(-408.753 -331.939)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5475",
    "data-name": "Group 5475",
    transform: "translate(47.3 112.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6182",
    "data-name": "Path 6182",
    d: "M435.07,323.966l-7.141,4.08a.8.8,0,0,0,.812,1.389l7.141-4.08A.8.8,0,0,0,435.07,323.966Z",
    transform: "translate(-427.538 -323.853)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5476",
    "data-name": "Group 5476",
    transform: "translate(60.099 101.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6183",
    "data-name": "Path 6183",
    d: "M447.718,310.279l-5.032,6.505c-.626.808.5,1.955,1.137,1.137l5.033-6.506C449.481,310.608,448.351,309.462,447.718,310.279Z",
    transform: "translate(-442.503 -309.998)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5477",
    "data-name": "Group 5477",
    transform: "translate(68.262 85.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6184",
    "data-name": "Path 6184",
    d: "M453.227,292.908q-.585,4.071-1.169,8.141c-.145,1.013,1.4,1.45,1.551.428l1.169-8.141C454.922,292.324,453.374,291.886,453.227,292.908Z",
    transform: "translate(-452.048 -292.326)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5478",
    "data-name": "Group 5478",
    transform: "translate(68.041 70.577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6185",
    "data-name": "Path 6185",
    d: "M453.35,274.985c-.146-1.02-1.7-.586-1.551.428q.582,4.071,1.167,8.142c.145,1.02,1.7.586,1.551-.428Q453.933,279.057,453.35,274.985Z",
    transform: "translate(-451.79 -274.403)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5479",
    "data-name": "Group 5479",
    transform: "translate(58.728 58.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6186",
    "data-name": "Path 6186",
    d: "M442.237,259.988c-.665-.8-1.8.347-1.138,1.137q2.638,3.156,5.273,6.313c.664.795,1.8-.348,1.137-1.137Z",
    transform: "translate(-440.9 -259.719)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5480",
    "data-name": "Group 5480",
    transform: "translate(43.523 51.657)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6187",
    "data-name": "Path 6187",
    d: "M432.17,254.025l-8.043-1.723c-1.009-.216-1.44,1.333-.428,1.551l8.043,1.723C432.751,255.792,433.182,254.241,432.17,254.025Z",
    transform: "translate(-423.122 -252.281)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5481",
    "data-name": "Group 5481",
    transform: "translate(27.139 51.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6188",
    "data-name": "Path 6188",
    d: "M412.918,251.747l-8.185.8c-1.02.1-1.031,1.71,0,1.608l8.185-.8C413.939,253.255,413.95,251.646,412.918,251.747Z",
    transform: "translate(-403.964 -251.743)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5482",
    "data-name": "Group 5482",
    transform: "translate(10.515 54.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6189",
    "data-name": "Path 6189",
    d: "M392.686,255.206l-7.624,3.086c-.947.383-.533,1.939.428,1.551l7.624-3.086C394.06,256.373,393.646,254.817,392.686,255.206Z",
    transform: "translate(-384.527 -255.144)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5483",
    "data-name": "Group 5483",
    transform: "translate(0 60.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6190",
    "data-name": "Path 6190",
    d: "M377.993,263.289l-5.543,6.077c-.7.763.438,1.9,1.137,1.137l5.542-6.077C379.826,263.663,378.692,262.522,377.993,263.289Z",
    transform: "translate(-372.232 -263.035)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5484",
    "data-name": "Group 5484",
    transform: "translate(63.907 38.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6191",
    "data-name": "Path 6191",
    d: "M446.963,242.243c-.109,3.668,1.116,9.137,5.128,17.283,4.012-8.146,5.238-13.615,5.128-17.283C457.025,235.7,447.157,235.7,446.963,242.243Zm5.128,3.507a3.066,3.066,0,1,1,3.066-3.066A3.066,3.066,0,0,1,452.091,245.75Z",
    transform: "translate(-446.956 -237.337)",
    fill: "#536dfe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5503",
    "data-name": "Group 5503",
    transform: "translate(853.561 415.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5487",
    "data-name": "Group 5487",
    transform: "translate(0 116.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6192",
    "data-name": "Path 6192",
    d: "M124.166,291.139q-5.709,3.777-11.411,7.563l-2.154,1.428c-.067-.148-.121-.261-.169-.376s-.1-.258-.155-.381c-.192-.4-.312-.46-.729-.313-.453.159-.9.337-1.35.5a.393.393,0,0,0-.288.533c.122.4.236.813.379,1.21.086.242,0,.366-.194.5-1.014.663-2.021,1.338-3.032,2.007-.636.422-1.276.84-1.953,1.285-.057-.153-.1-.269-.144-.384-.511-1.261-.973-2.546-1.547-3.778-1.391-2.988-2.833-5.953-4.264-8.924a.544.544,0,0,1,.028-.594q2.706-4.485,5.392-8.981c.05-.084.129-.2.108-.269-.093-.311-.219-.612-.357-.979l-7.412,6.023c-.655-.761-1.235-.978-1.929-.736-.731.253-1.038.779-1.067,1.856l-9.541.316a6.707,6.707,0,0,1,.243.663.634.634,0,0,0,.492.486q4.952,1.595,9.894,3.222a.572.572,0,0,1,.337.314c.5,1.761.978,3.53,1.472,5.294a70.45,70.45,0,0,0,2.542,8.265c.038.091.06.191.091.292a.627.627,0,0,1-.12.044c-1.961.258-3.922.517-5.886.763a.376.376,0,0,1-.3-.166c-.182-.369-.323-.758-.5-1.131s-.31-.437-.706-.3q-.632.222-1.255.467c-.444.173-.5.3-.359.763.075.243.176.478.274.739-.207.032-.331.051-.455.068q-7.823,1.024-15.646,2.049a5.9,5.9,0,0,0-.707.18l.68,1.819c.253.026.469.041.681.072q8.545,1.233,17.089,2.463a.485.485,0,0,1,.484.418c.07.323.185.637.281.955a1.705,1.705,0,0,0,.818,1.058,2.289,2.289,0,0,0,2.644-.991,4.663,4.663,0,0,0,.143-.789c.068.007.157.013.245.025,1.924.277,3.849.559,5.775.825a.516.516,0,0,1,.479.388c1.905,5.12,3.795,10.245,5.748,15.346a7.746,7.746,0,0,0,3.371,3.95,1.43,1.43,0,0,0,2.289-.848c.024-.064.049-.128.067-.2a8.135,8.135,0,0,0-.128-5.033c-1.87-5.1-3.79-10.174-5.7-15.255a.616.616,0,0,1,.123-.726c.911-1.027,1.8-2.075,2.7-3.115.417-.483.836-.964,1.274-1.469a1.474,1.474,0,0,0,2.075.464c.062-.03.128-.049.193-.073a1.477,1.477,0,0,0,.886-2.2c-.127-.269-.226-.553-.374-.81a.559.559,0,0,1,.107-.748q4.856-5.6,9.691-11.224c.662-.768,1.327-1.533,2.006-2.319q-.313-.835-.67-1.791A4.66,4.66,0,0,0,124.166,291.139Z",
    transform: "translate(-71.791 -281.187)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5488",
    "data-name": "Group 5488",
    transform: "translate(20.607 103.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6193",
    "data-name": "Path 6193",
    d: "M95.886,267.2v8.225a.8.8,0,0,0,1.609,0V267.2A.8.8,0,0,0,95.886,267.2Z",
    transform: "translate(-95.886 -266.421)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5489",
    "data-name": "Group 5489",
    transform: "translate(21.204 89.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6194",
    "data-name": "Path 6194",
    d: "M98.172,249.668q-.785,4.037-1.571,8.073c-.2,1.011,1.353,1.444,1.551.428q.786-4.037,1.571-8.073C99.919,249.085,98.37,248.652,98.172,249.668Z",
    transform: "translate(-96.584 -249.088)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5490",
    "data-name": "Group 5490",
    transform: "translate(25.411 74.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6195",
    "data-name": "Path 6195",
    d: "M104.961,232.405l-3.379,7.5c-.422.936.964,1.755,1.389.812l3.379-7.5C106.771,232.281,105.386,231.462,104.961,232.405Z",
    transform: "translate(-101.503 -231.987)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5491",
    "data-name": "Group 5491",
    transform: "translate(32.461 58.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6196",
    "data-name": "Path 6196",
    d: "M113.2,214.087l-3.379,7.5c-.422.936.964,1.754,1.388.812l3.38-7.5C115.014,213.963,113.629,213.145,113.2,214.087Z",
    transform: "translate(-109.746 -213.669)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5492",
    "data-name": "Group 5492",
    transform: "translate(39.119 44.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6197",
    "data-name": "Path 6197",
    d: "M120.989,197.6l-3.379,7.5c-.422.936.964,1.754,1.388.812l3.38-7.5C122.8,197.477,121.414,196.659,120.989,197.6Z",
    transform: "translate(-117.531 -197.183)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5493",
    "data-name": "Group 5493",
    transform: "translate(51.986 35.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6198",
    "data-name": "Path 6198",
    d: "M141.306,186.306l-8.146,1.132c-1.021.142-.587,1.692.427,1.551l8.146-1.132C142.753,187.715,142.319,186.165,141.306,186.306Z",
    transform: "translate(-132.577 -186.297)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5494",
    "data-name": "Group 5494",
    transform: "translate(53.451 22.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6199",
    "data-name": "Path 6199",
    d: "M140.5,171.04l-5.963,5.665c-.751.714.387,1.85,1.137,1.137l5.962-5.665C142.387,171.462,141.248,170.326,140.5,171.04Z",
    transform: "translate(-134.289 -170.813)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5495",
    "data-name": "Group 5495",
    transform: "translate(64.953 10.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6200",
    "data-name": "Path 6200",
    d: "M153.676,157.607l-5.709,5.92c-.719.746.417,1.884,1.137,1.137l5.71-5.92C155.532,158,154.4,156.86,153.676,157.607Z",
    transform: "translate(-147.738 -157.363)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5496",
    "data-name": "Group 5496",
    transform: "translate(77.381 1.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6201",
    "data-name": "Path 6201",
    d: "M170.125,146.993l-7.441,3.5c-.936.44-.121,1.827.812,1.388l7.441-3.5C171.871,147.94,171.056,146.554,170.125,146.993Z",
    transform: "translate(-162.27 -146.908)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5497",
    "data-name": "Group 5497",
    transform: "translate(92.088 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6202",
    "data-name": "Path 6202",
    d: "M188.444,144.83l-8.206.563c-1.026.07-1.034,1.679,0,1.608l8.206-.563C189.471,146.367,189.478,144.759,188.444,144.83Z",
    transform: "translate(-179.466 -144.827)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5498",
    "data-name": "Group 5498",
    transform: "translate(109.408 0.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6203",
    "data-name": "Path 6203",
    d: "M208.65,146.457l-8.167-.97c-1.026-.121-1.017,1.487,0,1.608l8.167.97C209.675,148.186,209.667,146.577,208.65,146.457Z",
    transform: "translate(-199.717 -145.48)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5499",
    "data-name": "Group 5499",
    transform: "translate(67.676 35.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6204",
    "data-name": "Path 6204",
    d: "M159.869,187.206l-8.179-.867c-1.028-.109-1.02,1.5,0,1.608l8.179.867C160.9,188.923,160.889,187.314,159.869,187.206Z",
    transform: "translate(-150.922 -186.334)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5500",
    "data-name": "Group 5500",
    transform: "translate(82.979 37.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6205",
    "data-name": "Path 6205",
    d: "M177.87,190.183l-8.05-1.687c-1.01-.211-1.441,1.338-.428,1.551l8.05,1.687C178.453,191.945,178.885,190.4,177.87,190.183Z",
    transform: "translate(-168.815 -188.477)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5501",
    "data-name": "Group 5501",
    transform: "translate(42.395 10.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6206",
    "data-name": "Path 6206",
    d: "M121.368,161.646c-.109,3.667,1.116,9.136,5.128,17.283,4.012-8.147,5.238-13.615,5.128-17.283C131.43,155.1,121.562,155.1,121.368,161.646Zm5.128,3.507a3.066,3.066,0,1,1,3.066-3.066A3.066,3.066,0,0,1,126.5,165.153Z",
    transform: "translate(-121.361 -156.74)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5502",
    "data-name": "Group 5502",
    transform: "translate(44.825 34.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6207",
    "data-name": "Path 6207",
    d: "M126.723,185.884l-2.407,4.169a.8.8,0,0,0,1.388.812l2.408-4.169A.8.8,0,0,0,126.723,185.884Z",
    transform: "translate(-124.203 -185.494)",
    fill: "#536dfe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5504",
    "data-name": "Group 5504",
    transform: "translate(997.166 473.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6208",
    "data-name": "Path 6208",
    d: "M373.648,277.327c-3.525-19.586-16.058-30.16-25.065-37.993s-16.841-27.416-16.841-27.416l-58.356,18.408L239.7,282.807v2.349s28.59,45.823,45.822,49.348c23.333,4.773,47.177,17.5,65.941,31.841,10.418,7.96,16.915,15.872,31.05,15.973,11.246.08,23.207-4.678,28.906-14.857,9.462-16.9-11.787-31.568-18.919-44.481C384.758,308.956,376.516,293.256,373.648,277.327Z",
    transform: "translate(-239.704 -211.918)",
    fill: "#ffefd9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6209",
    "data-name": "Path 6209",
    d: "M116.478,149.538a16.45,16.45,0,0,1-17.42,15.4l-4.214,72.4a16.416,16.416,0,0,1,15.518,17.284l179.4,10.279a5.409,5.409,0,0,0,5.728-5.062l5.49-94.339a5.4,5.4,0,0,0-5.1-5.682Z",
    transform: "translate(778.432 270.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6210",
    "data-name": "Path 6210",
    d: "M412.642,255.654l4.213-72.4a16.416,16.416,0,0,1-15.518-17.284L340.3,162.256a5.042,5.042,0,0,0-5.339,4.719l-5.533,95.065a5.032,5.032,0,0,0,4.757,5.3l61.037,3.713A16.45,16.45,0,0,1,412.642,255.654Z",
    transform: "translate(744.477 268.589)",
    fill: "#536dfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6211",
    "data-name": "Path 6211",
    d: "M328.864,161.556l-4.8-.275c2.612.15,4.589,2.675,4.417,5.643l-5.491,94.338c-.173,2.967-2.43,5.25-5.041,5.1l4.8.275c2.612.15,4.869-2.135,5.042-5.1l5.49-94.339C333.452,164.232,331.475,161.705,328.864,161.556Z",
    transform: "translate(746.137 268.729)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5505",
    "data-name": "Group 5505",
    transform: "translate(893.283 455.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6212",
    "data-name": "Path 6212",
    d: "M127.333,225.616l1.623-27.9-10.718-.614.352-6.056,29.03,1.663-.352,6.056-10.718-.614-1.623,27.9Z",
    transform: "translate(-118.238 -191.047)",
    fill: "#536dfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6213",
    "data-name": "Path 6213",
    d: "M154.947,227.213l1.976-33.954,7.5.429-1.976,33.955Z",
    transform: "translate(-123.552 -191.367)",
    fill: "#536dfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6214",
    "data-name": "Path 6214",
    d: "M178.836,226.913a14.684,14.684,0,0,1-5.58-6.444,21.354,21.354,0,0,1,1.066-18.313,14.57,14.57,0,0,1,6.289-5.74,18.417,18.417,0,0,1,9.184-1.628,20.631,20.631,0,0,1,6.453,1.4,13.4,13.4,0,0,1,4.9,3.176l-2.666,5.206a17.619,17.619,0,0,0-4.349-2.761,13.463,13.463,0,0,0-4.544-1.05,8.747,8.747,0,0,0-7.235,2.5q-2.62,2.77-2.945,8.348-.327,5.628,1.953,8.7a8.692,8.692,0,0,0,6.895,3.338,13.483,13.483,0,0,0,4.635-.523,17.675,17.675,0,0,0,4.64-2.247l2.044,5.476a13.424,13.424,0,0,1-5.238,2.595,20.653,20.653,0,0,1-6.573.653A18.234,18.234,0,0,1,178.836,226.913Z",
    transform: "translate(-125.974 -191.583)",
    fill: "#536dfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6215",
    "data-name": "Path 6215",
    d: "M241.681,232.182l-9.036-.517-13.987-16.543-.913,15.689-7.5-.429,1.976-33.955,7.5.43-.869,14.927,15.24-14.1,8.94.512-16.853,15.3Z",
    transform: "translate(-131.557 -191.826)",
    fill: "#536dfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6216",
    "data-name": "Path 6216",
    d: "M248.743,232.587l1.976-33.954,23.6,1.352-.335,5.77-16.294-.934-.466,8.012,15.284.876-.339,5.818-15.284-.876-.5,8.584,16.293.933-.335,5.77Z",
    transform: "translate(-137.129 -192.145)",
    fill: "#536dfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6217",
    "data-name": "Path 6217",
    d: "M290.532,234.966l1.624-27.9-10.718-.614.352-6.057,29.03,1.663-.352,6.057L299.75,207.5l-1.624,27.9Z",
    transform: "translate(-141.862 -192.4)",
    fill: "#536dfe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5507",
    "data-name": "Group 5507",
    transform: "translate(955.016 481.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6218",
    "data-name": "Path 6218",
    d: "M236.171,263.556c-.389-1.731-.8-3.5-1.252-5.293-4.7-18.8-10.574-26.241-14.883-28.2s0,22.324,0,22.324-5.875-14.49-14.49-23.89-17.625-9.4-14.491-3.524,8.617,44.256,9.008,47.389,19.973,23.5,19.973,23.5c19.583,45.04,74.414,40.731,74.414,40.731s-33.682-26.241-43.865-35.248C241.376,293.2,239.854,279.926,236.171,263.556Z",
    transform: "translate(-190.418 -220.93)",
    fill: "#ffefd9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5508",
    "data-name": "Group 5508",
    transform: "translate(910.492 485.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6219",
    "data-name": "Path 6219",
    d: "M143.962,228.787c-10.183,4.7-4.7,7.833,2.35,10.575s39.557,19.973,47,27.023,9.4-7.05,9.4-7.05l-41.124-33.29S154.145,224.088,143.962,228.787Z",
    transform: "translate(-138.359 -225.641)",
    fill: "#ffefd9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFlights);
export default __webpack_public_path__ + "static/media/empty-flights.347f09a9.svg";
export { ForwardRef as ReactComponent };